import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const Agent = (props) => {
  const {
    agent: {
      full_name, first_name, mobile, email, default_image,
    },
    campaign: { address },
  } = props

  const mobileTrim = mobile ? mobile.replace(/\s/g, '') : ''

  return (
    <div className={styles.root}>
      <span className={styles.image} style={{ backgroundImage: default_image ? `url(${default_image})` : null }} />
      <div className={styles.details}>
        <span className={styles.name}>{full_name}</span>
        <a className={styles.phone} href={`tel:${mobileTrim}`}>
          {mobile}
        </a>
        <a className={styles.email} href={`mailto:${email}?subject=Proposal for ${address}`} target="_top">
          {`Email ${first_name}`}
        </a>
      </div>
    </div>
  )
}

Agent.propTypes = {
  agent: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Agent
